import { Component, OnInit, OnDestroy } from "@angular/core";
import { TotalDiscount } from "@edp-models/edp-total-discount.model";
import { Subject } from "rxjs";
import { Store, select } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { takeUntil } from "rxjs/operators";
import { getPartnerInfo } from "@edp-store/selectors/contract.selectors";
import { PartnerInfo } from "@edp-models/edp-partner-info.model";

@Component({
    selector: "edp-widget-savings",
    templateUrl: "./edp-widget-savings.component.html",
    styleUrls: ["./edp-widget-savings.component.scss"],
})
export class EdpWidgetSavingsComponent implements OnInit, OnDestroy {
    public discounts: TotalDiscount;
    public value: string;
    private unsubscribe = new Subject();

    constructor(
        private store: Store<IAppState>
    ) {}

    public ngOnInit() {
        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getPartnerInfo)
        ).subscribe((partnerInfo: PartnerInfo) => {
            if (partnerInfo && partnerInfo.totalDiscounts) {
                this.discounts = {
                    ...partnerInfo.totalDiscounts,
                    firstDiscountDate: partnerInfo.totalDiscounts.firstDiscountDate.replace(/-/g, "/"),
                };
                this.value = this.discounts.value.toString().replace(".", ",");
            } else {
                this.discounts = null;
            }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
